<template>
  <div class="plan-selector">
    <div class="plan-selector__content">
      <h1 class="plan-selector__content--title">方案選擇</h1>
      <div class="choose-plan columns is-vcentered">
        <div class="column">
          <div class="choose-plan__box current">
            <h2 class="choose-plan__box--title">輕量方案</h2>
            <p class="choose-plan__box--description">適合小型、新創團隊</p>
            <ul class="choose-plan__box--feature">
              <li>不限時免費使用</li>
              <li>自由邀請成員加入</li>
              <li>管理後台報表統計</li>
            </ul>
            <p class="choose-plan__box--price">$0</p>
            <p class="choose-plan__box--condition">最多可邀請10位成員</p>
          </div>
        </div>
        <div class="column">
          <div class="choose-plan__box">
            <h2 class="choose-plan__box--title">標準方案</h2>
            <p class="choose-plan__box--description">大型企業、集團公司</p>
            <p class="my-4">人員數量</p>
            <div class="choose-plan__box--slider level">
              <span>11</span>
              <b-slider
                v-model="memberCount"
                :min="11"
                :max="999"
                class="mx-3"
                rounded
              />
              <span>999</span>
            </div>
            <ul class="choose-plan__box--feature">
              <li>銅板費用低負擔</li>
              <li>自由邀請成員加入</li>
              <li>支援名單匯入</li>
              <li>報表匯出功能</li>
            </ul>
            <p class="choose-plan__box--price">
              ${{ standardPlanPrice }}
              <small>/月 (每人${{ unitPrice }}/月)*</small>
            </p>
            <!-- <b-button
              type="is-primary"
              class="choose-plan__box--action"
              expanded
              @click="onUpgrade">
              立即升級
            </b-button> -->
            <b-button
              type="is-primary"
              class="choose-plan__box--action"
              expanded
              @click="enableContactModal = true"
            >
              專人與您聯繫
            </b-button>
          </div>
        </div>
        <div class="column">
          <div class="choose-plan__box">
            <h2 class="choose-plan__box--title">企業方案</h2>
            <p class="choose-plan__box--description">大型企業、集團公司</p>
            <p class="choose-plan__box--feature">
              好彙訂提供客製化服務，為企業量身訂做，與內部現有資訊系統無縫接軌
            </p>
            <ul class="choose-plan__box--feature">
              <li>整合差勤及門禁系統</li>
              <li>串接企業ERP系統</li>
              <li>整合員工資料系統</li>
            </ul>
            <b-button
              type="is-primary"
              class="choose-plan__box--action"
              expanded
              @click="enableContactModal = true"
            >
              專人與您聯繫
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="plan-selector__footer">
      <p>*備註：</p>
      <ol>
        <li>
          每月1號將依據上月實際啟用之組織成員人數及使用天數計費。組織成員啟用及停用當日均納入使用之天數計算。每月天數以30天計算。
        </li>
      </ol>
    </div>

    <w-modal v-model="enableContactModal" :width="1000">
      <template #header>聯絡我們</template>
      <template #content>
        <div class="columns">
          <div class="column">
            <b-field
              horizontal
              label="姓名"
              class="required"
              :type="{ 'is-danger': v$.contactForm.name.$error }"
              :message="
                v$.contactForm.name.$error
                  ? v$.contactForm.name.$errors[0].$message
                  : ''
              "
            >
              <b-input v-model="contactForm.name" />
            </b-field>
            <b-field
              horizontal
              label="公司名稱"
              class="required"
              :type="{ 'is-danger': v$.contactForm.team_name.$error }"
              :message="
                v$.contactForm.team_name.$error
                  ? v$.contactForm.team_name.$errors[0].$message
                  : ''
              "
            >
              <b-input v-model="contactForm.team_name" />
            </b-field>
            <b-field
              horizontal
              label="電子郵件"
              class="required"
              :type="{ 'is-danger': v$.contactForm.email.$error }"
              :message="
                v$.contactForm.email.$error
                  ? v$.contactForm.email.$errors[0].$message
                  : ''
              "
            >
              <b-input v-model="contactForm.email" type="email" />
            </b-field>
            <b-field
              horizontal
              label="公司規模"
              class="required"
              :type="{ 'is-danger': v$.contactForm.scale.$error }"
              :message="
                v$.contactForm.scale.$error
                  ? v$.contactForm.scale.$errors[0].$message
                  : ''
              "
            >
              <b-select
                v-model.number="contactForm.scale"
                placeholder="請選擇一項"
                expanded
                required
              >
                <option
                  v-for="(scale, index) in scaleList"
                  :value="index + 1"
                  :key="`scale-${scale}`"
                >
                  {{ scale }}
                </option>
              </b-select>
            </b-field>
            <b-field
              horizontal
              label="連絡電話"
              class="required"
              :type="{ 'is-danger': v$.contactForm.phone.$error }"
              :message="
                v$.contactForm.phone.$error
                  ? v$.contactForm.phone.$errors[0].$message
                  : ''
              "
            >
              <b-input v-model="contactForm.phone" />
            </b-field>
          </div>
          <div class="column">
            <b-field horizontal label="所在縣市">
              <b-select
                v-model="contactForm.city"
                placeholder="請選擇一項"
                expanded
              >
                <option
                  v-for="city in cityList"
                  :value="city"
                  :key="`city-${city}`"
                >
                  {{ city }}
                </option>
              </b-select>
            </b-field>
            <b-field horizontal label="聯繫時段">
              <b-radio
                v-model.number="contactForm.contact_time"
                name="contact_time"
                native-value="0"
              >
                09:00-13:00
              </b-radio>
              <b-radio
                v-model.number="contactForm.contact_time"
                name="contact_time"
                native-value="1"
              >
                14:00-18:00
              </b-radio>
            </b-field>
            <b-field horizontal label="需求說明">
              <b-input v-model="contactForm.requests" type="textarea" placeholder="詢問內容" />
            </b-field>
          </div>
        </div>
      </template>
      <template #footer>
        <b-button type="is-primary" @click="onSubmit">送出</b-button>
      </template>
    </w-modal>
  </div>
</template>

<script>
import PlanSelector from './PlanSelector';

export default PlanSelector;
</script>

<style lang="scss" scoped>
@import 'PlanSelector';
</style>
